import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import LightRays from "./LightRays";
import QRCodePopup from "./QRCodePopup";
import { useCapacitySync } from "../hooks/useCapacitySync";

const ReservationPage = () => {
  // Auto-sync capacity when page loads
  const { isSyncing, syncResult } = useCapacitySync(true, 500);

  const [formData, setFormData] = useState({
    team_name: "",
    team_number: 1,
    time_slot: "",
    password: "",
  });
  const [formData2, setFormData2] = useState({
    team_name: "",
    team_number: 1,
    time_slot: "",
    password: "",
  });
  const [formData3, setFormData3] = useState({
    team_name: "",
    team_number: 1,
    time_slot: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [errors2, setErrors2] = useState({});
  const [errors3, setErrors3] = useState({});
  const [timeAvailability, setTimeAvailability] = useState({});
  const [timeAvailability2, setTimeAvailability2] = useState({});
  const [timeAvailability3, setTimeAvailability3] = useState({});
  const [capacityInfo, setCapacityInfo] = useState({});
  const [capacityInfo2, setCapacityInfo2] = useState({});
  const [capacityInfo3, setCapacityInfo3] = useState({});
  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrReservationData, setQrReservationData] = useState(null);

  // Fetch time slot availability when dropdown is clicked
  const fetchTimeAvailability = async () => {
    try {
      const response = await fetch("/backend/get_time_availability.php");
      if (response.ok) {
        const data = await response.json();
        setTimeAvailability(data.availability);
        setCapacityInfo(data.capacity_info || {});
      }
    } catch (error) {
      console.error("Failed to fetch time availability:", error);
    }
  };

  // Fetch time slot availability for second form
  const fetchTimeAvailability2 = async () => {
    try {
      const response = await fetch("/backend/get_time_availability_mira.php");
      if (response.ok) {
        const data = await response.json();
        setTimeAvailability2(data.availability);
        setCapacityInfo2(data.capacity_info || {});
      }
    } catch (error) {
      console.error("Failed to fetch time availability:", error);
    }
  };

  // Fetch time slot availability for third form
  const fetchTimeAvailability3 = async () => {
    try {
      const response = await fetch("/backend/get_time_availability_third.php");
      if (response.ok) {
        const data = await response.json();
        setTimeAvailability3(data.availability);
        setCapacityInfo3(data.capacity_info || {});
      }
    } catch (error) {
      console.error("Failed to fetch time availability:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;
    setFormData2((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors2[name]) {
      setErrors2((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleInputChange3 = (e) => {
    const { name, value } = e.target;
    setFormData3((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors3[name]) {
      setErrors3((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); // Clear previous errors

    try {
      const response = await fetch("/backend/create_reservation.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        
        // If the error has a field property, show it next to that field
        if (errorData.field) {
          setErrors({
            [errorData.field]: errorData.error
          });
          return;
        }
        
        throw new Error(errorData.error || "Failed to create reservation");
      }

      const data = await response.json();
      
      // Set QR code data and show popup
      setQrReservationData({
        id: data.reservation.id,
        team_name: formData.team_name,
        team_number: formData.team_number,
        time_slot: formData.time_slot,
        password: formData.password,
        table: 'reservations' // First table
      });
      setQrPopupOpen(true);

      // Reset form
      setFormData({
        team_name: "",
        team_number: 1,
        time_slot: "",
        password: "",
      });
      setErrors({});
      
      // Refresh time availability
      const availabilityResponse = await fetch("/backend/get_time_availability.php");
      if (availabilityResponse.ok) {
        const availabilityData = await availabilityResponse.json();
        setTimeAvailability(availabilityData.availability);
      }
    } catch (err) {
      alert(`Chyba při vytváření rezervace: ${err.message}`);
    }
  };

  const handleSubmit2 = async (e) => {
    e.preventDefault();
    setErrors2({}); // Clear previous errors

    try {
      const response = await fetch("/backend/create_reservation_mira.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData2),
      });

      if (!response.ok) {
        const errorData = await response.json();
        
        // If the error has a field property, show it next to that field
        if (errorData.field) {
          setErrors2({
            [errorData.field]: errorData.error
          });
          return;
        }
        
        throw new Error(errorData.error || "Failed to create reservation");
      }

      const data = await response.json();
      
      // Set QR code data and show popup
      setQrReservationData({
        id: data.reservation.id,
        team_name: formData2.team_name,
        team_number: formData2.team_number,
        time_slot: formData2.time_slot,
        password: formData2.password,
        table: 'reservations_mira' // Second table
      });
      setQrPopupOpen(true);

      // Reset form
      setFormData2({
        team_name: "",
        team_number: 1,
        time_slot: "",
        password: "",
      });
      setErrors2({});
      
      // Refresh time availability
      const availabilityResponse = await fetch("/backend/get_time_availability_mira.php");
      if (availabilityResponse.ok) {
        const availabilityData = await availabilityResponse.json();
        setTimeAvailability2(availabilityData.availability);
      }
    } catch (err) {
      alert(`Chyba při vytváření rezervace 2: ${err.message}`);
    }
  };

  const handleSubmit3 = async (e) => {
    e.preventDefault();
    setErrors3({}); // Clear previous errors

    try {
      const response = await fetch("/backend/create_reservation_third.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData3),
      });

      if (!response.ok) {
        const errorData = await response.json();
        
        // If the error has a field property, show it next to that field
        if (errorData.field) {
          setErrors3({
            [errorData.field]: errorData.error
          });
          return;
        }
        
        throw new Error(errorData.error || "Failed to create reservation");
      }

      const data = await response.json();
      
      // Set QR code data and show popup
      setQrReservationData({
        id: data.reservation.id,
        team_name: formData3.team_name,
        team_number: formData3.team_number,
        time_slot: formData3.time_slot,
        password: formData3.password,
        table: 'reservations_third' // Third table
      });
      setQrPopupOpen(true);

      // Reset form
      setFormData3({
        team_name: "",
        team_number: 1,
        time_slot: "",
        password: "",
      });
      setErrors3({});
      
      // Refresh time availability
      const availabilityResponse = await fetch("/backend/get_time_availability_third.php");
      if (availabilityResponse.ok) {
        const availabilityData = await availabilityResponse.json();
        setTimeAvailability3(availabilityData.availability);
      }
    } catch (err) {
      alert(`Chyba při vytváření rezervace 3: ${err.message}`);
    }
  };

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Light Rays Background */}
      <div className="fixed inset-0 w-full h-full" style={{ zIndex: 1 }}>
        <LightRays
          raysOrigin="top-center"
          raysColor="#00ff41"
          raysSpeed={1.5}
          lightSpread={0.8}
          rayLength={2.5}
          fadeDistance={2.0}
          followMouse={true}
          mouseInfluence={0.1}
          noiseAmount={0.1}
          distortion={0.05}
          className="custom-rays"
        />
      </div>
      
      {/* Creepy Background Elements */}
      <div className="absolute inset-0 opacity-10" style={{ zIndex: 2 }}>
        <div className="absolute top-20 left-10 w-32 h-32 border border-green-500 rounded-full animate-beetlejuice-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-green-400 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "1s" }}></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-green-600 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "2s" }}></div>
        <div className="absolute top-1/2 right-1/3 w-20 h-20 border border-green-300 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "3s" }}></div>
      </div>

      {/* Navigation */}
      <div style={{ position: 'relative', zIndex: 10 }}>
        <Navigation />
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" style={{ position: 'relative', zIndex: 10 }}>
        <div className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-black text-green-400 mb-6 drop-shadow-2xl animate-fade-in">
            🦇 FAKULTA STRAŠIDEL 🦇
          </h1>
          <div className="text-4xl md:text-5xl text-green-300 mb-8 font-black animate-beetlejuice-pulse drop-shadow-2xl">
            BEETLEJUICE, BEETLEJUICE, BEETLE…
          </div>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            🦇 Připojte se k nám v záhrobí, kterým vás bude provázet Beetlejuice! 
            <br />
            🧪 Vyplňte formulář níže a zarezervujte si místo v jedné z aktivit.
            <br />
            💀 Dokážeš splnit všechny úkoly a uniknout ze záhrobí do světa živých?
          </p>
        </div>

        {/* Capacity Sync Status */}
        {isSyncing && (
          <div className="mb-4 bg-blue-900/30 border-2 border-blue-600 rounded-2xl p-4 backdrop-blur-sm max-w-4xl mx-auto">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2">
                <div className="animate-spin w-4 h-4 border-2 border-blue-400 border-t-transparent rounded-full"></div>
                <p className="text-blue-200 text-sm">
                  🔄 Synchronizing capacity data...
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Important Reminders */}
        <div className="mb-8 space-y-4">
          <div className="bg-red-900/30 border-2 border-red-600 rounded-2xl p-6 backdrop-blur-sm max-w-4xl mx-auto">
            <div className="text-center">
              <h3 className="text-xl font-bold text-red-400 mb-2 drop-shadow-lg">
                🚨 DŮLEŽITÉ UPOZORNĚNÍ
              </h3>
              <p className="text-red-200 text-base leading-relaxed">
                <strong>Na stezku i aktivity se dostavte alespoň s 15 minutovým předstihem, jinak vám budou brány záhrobí nenávratně uzavřeny.</strong>
              </p>
            </div>
          </div>
          
          <div className="bg-yellow-900/30 border-2 border-yellow-600 rounded-2xl p-6 backdrop-blur-sm max-w-4xl mx-auto">
            <div className="text-center">
              <h3 className="text-xl font-bold text-yellow-400 mb-2 drop-shadow-lg">
                ⚠️ DŮLEŽITÉ UPOZORNĚNÍ
              </h3>
              <p className="text-yellow-200 text-base leading-relaxed">
                <strong>Zapamatujte si název vašeho týmu a heslo!</strong> Tyto údaje jsou nutné pro zrušení nebo změnu času rezervace. 
                Informace jsou uvedeny v QR kódu, který si pečlivě uschovejte. Při přihlášení na všechny aktivity doporučujeme stejné heslo.
                Bez názvu týmu a hesla nebudeme moci najít vaši rezervaci v systému.
              </p>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-stretch">
          {/* First Reservation Form - Stezka záhrobím s Beetlejuicem - MAIN */}
          <div className="bg-gradient-to-br from-green-900/90 to-gray-900/80 border-4 border-green-500 rounded-3xl shadow-2xl p-8 backdrop-blur-sm beetlejuice-glow flex flex-col h-full relative overflow-hidden">
            {/* Main Badge */}
            <div className="absolute top-2 right-4 bg-green-500 text-black px-3 py-1 rounded-full text-xs font-bold animate-pulse">
              HLAVNÍ AKTIVITA
            </div>
            <h2 className="text-3xl font-bold text-green-300 mb-6 text-center drop-shadow-2xl animate-pulse">
              🦇 Stezka záhrobím s Beetlejuicem 🦇
            </h2>
            <p className="text-gray-300 mb-6 text-center text-sm leading-relaxed h-20 flex items-center justify-center">
              Vhodné pro mladší s doprovodem (registrujte celkový počet účastníků, tj. děti včetně dospělých). Délka trasy: ~ 30 min (podle odvahy)
            </p>

            <form onSubmit={handleSubmit} className="space-y-6 flex flex-col flex-grow">
              {/* Team Information */}
              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  🦇 Název týmu *
                </label>
                <input
                  type="text"
                  name="team_name"
                  value={formData.team_name}
                  onChange={handleInputChange}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors.team_name ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte název vašeho týmu"
                />
                {errors.team_name && (
                  <p className="text-red-400 text-sm mt-1">{errors.team_name}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  🔐 Heslo *
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                  minLength="4"
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors.password ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte heslo (min. 4 znaky)"
                />
                {errors.password && (
                  <p className="text-red-400 text-sm mt-1">{errors.password}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  👥 Počet účastníků *
                </label>
                <select
                  name="team_number"
                  value={formData.team_number}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-green-600 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <option key={num} value={num}>
                      {num} {num === 1 ? "Účastník" : "Účastníků"}
                    </option>
                  ))}
                </select>
              </div>


              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  ⏰ Časový slot *
                </label>
                <select
                  name="time_slot"
                  value={formData.time_slot}
                  onChange={handleInputChange}
                  onClick={fetchTimeAvailability}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white ${
                    errors.time_slot ? 'border-red-500' : 'border-green-600'
                  }`}
                >
                  <option value="">Vyberte čas</option>
                  {[
                    { value: "15:00", label: "15:00" },
                    { value: "15:10", label: "15:10" },
                    { value: "15:20", label: "15:20" },
                    { value: "15:30", label: "15:30" },
                    { value: "15:40", label: "15:40" },
                    { value: "16:00", label: "16:00" },
                    { value: "16:10", label: "16:10" },
                    { value: "16:20", label: "16:20" },
                    { value: "16:30", label: "16:30" },
                    { value: "16:40", label: "16:40" },
                    { value: "17:00", label: "17:00" },
                    { value: "17:10", label: "17:10" },
                    { value: "17:20", label: "17:20" },
                    { value: "17:30", label: "17:30" },
                    { value: "17:40", label: "17:40" },
                    { value: "18:00", label: "18:00" },
                    { value: "18:10", label: "18:10" },
                    { value: "18:20", label: "18:20" },
                    { value: "18:30", label: "18:30" },
                    { value: "18:40", label: "18:40" },
                    { value: "19:00", label: "19:00" },
                    { value: "19:10", label: "19:10" },
                    { value: "19:20", label: "19:20" },
                    { value: "19:30", label: "19:30" },
                    { value: "19:40", label: "19:40" }
                  ].map((slot) => {
                    const isAvailable = timeAvailability[slot.value] !== false;
                    const isTaken = timeAvailability[slot.value] === false;
                    const capacity = capacityInfo[slot.value];
                    const availableSpots = capacity?.available_spots || 0;
                    const maxCapacity = capacity?.max_capacity || 8;
                    
                    return (
                      <option 
                        key={slot.value} 
                        value={slot.value}
                        style={{
                          backgroundColor: isTaken ? '#fee2e2' : isAvailable ? '#dcfce7' : 'white',
                          color: isTaken ? '#dc2626' : isAvailable ? '#16a34a' : 'black'
                        }}
                        disabled={isTaken}
                      >
                        {slot.label} {isTaken ? '(Obsazeno)' : isAvailable ? `(${availableSpots}/${maxCapacity} míst)` : ''}
                      </option>
                    );
                  })}
                </select>
                {errors.time_slot && (
                  <p className="text-red-400 text-sm mt-1">{errors.time_slot}</p>
                )}
              </div>

              <div className="mt-auto">
                <button
                  type="submit"
                  className="w-full beetlejuice-green text-black py-4 rounded-xl text-lg font-bold beetlejuice-hover beetlejuice-border beetlejuice-glow shadow-2xl shadow-green-500/50 animate-pulse"
                >
                  Rezervovat Stezku záhrobím
                </button>

                <div className="text-center pt-4">
                <p className="text-gray-300 mb-3">Už máte rezervaci?</p>
                <Link
                  to="/manage"
                  className="inline-block bg-gray-800 hover:bg-gray-700 text-gray-300 px-6 py-2 rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:scale-105 border border-green-600 hover:border-green-500"
                >
                  Spravovat Existující Rezervace
                </Link>
                </div>
              </div>
            </form>
          </div>

          {/* Second Reservation Form - Dům, kde šepot nezmizel */}
          <div className="bg-gray-900/80 border-2 border-green-800 rounded-3xl shadow-2xl p-8 backdrop-blur-sm beetlejuice-glow flex flex-col h-full">
            <h2 className="text-2xl font-bold text-green-400 mb-6 text-center drop-shadow-lg">
              👻 Dům, kde šepot nezmizel 👻
            </h2>
            <p className="text-gray-300 mb-6 text-center text-sm leading-relaxed h-20 flex items-center justify-center">
              Vhodné pro starší. Délka aktivity: ~ 10 min
            </p>

            <form onSubmit={handleSubmit2} className="space-y-6 flex flex-col flex-grow">
              {/* Team Information */}
              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  👻 Název týmu *
                </label>
                <input
                  type="text"
                  name="team_name"
                  value={formData2.team_name}
                  onChange={handleInputChange2}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors2.team_name ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte název vašeho týmu"
                />
                {errors2.team_name && (
                  <p className="text-red-400 text-sm mt-1">{errors2.team_name}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  🔐 Heslo *
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData2.password}
                  onChange={handleInputChange2}
                  required
                  minLength="4"
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors2.password ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte heslo (min. 4 znaky)"
                />
                {errors2.password && (
                  <p className="text-red-400 text-sm mt-1">{errors2.password}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  👥 Počet účastníků *
                </label>
                <select
                  name="team_number"
                  value={formData2.team_number}
                  onChange={handleInputChange2}
                  required
                  className="w-full px-4 py-3 border border-green-600 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white"
                >
                  {[1, 2, 3, 4].map((num) => (
                    <option key={num} value={num}>
                      {num} {num === 1 ? "Účastník" : "Účastníků"}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  ⏰ Časový slot *
                </label>
                <select
                  name="time_slot"
                  value={formData2.time_slot}
                  onChange={handleInputChange2}
                  onClick={fetchTimeAvailability2}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white ${
                    errors2.time_slot ? 'border-red-500' : 'border-green-600'
                  }`}
                >
                  <option value="">Vyberte čas</option>
                  {[
                    { value: "15:00", label: "15:00" },
                    { value: "15:15", label: "15:15" },
                    { value: "15:30", label: "15:30" },
                    { value: "16:00", label: "16:00" },
                    { value: "16:15", label: "16:15" },
                    { value: "16:30", label: "16:30" },
                    { value: "17:00", label: "17:00" },
                    { value: "17:15", label: "17:15" },
                    { value: "17:30", label: "17:30" },
                    { value: "18:00", label: "18:00" },
                    { value: "18:15", label: "18:15" },
                    { value: "18:30", label: "18:30" },
                    { value: "19:00", label: "19:00" },
                    { value: "19:15", label: "19:15" },
                    { value: "19:30", label: "19:30" }
                  ].map((slot) => {
                    const isAvailable = timeAvailability2[slot.value] !== false;
                    const isTaken = timeAvailability2[slot.value] === false;
                    const capacity = capacityInfo2[slot.value];
                    const availableSpots = capacity?.available_spots || 0;
                    const maxCapacity = capacity?.max_capacity || 4;
                    
                    return (
                      <option 
                        key={slot.value} 
                        value={slot.value}
                        style={{
                          backgroundColor: isTaken ? '#fee2e2' : isAvailable ? '#dcfce7' : 'white',
                          color: isTaken ? '#dc2626' : isAvailable ? '#16a34a' : 'black'
                        }}
                        disabled={isTaken}
                      >
                        {slot.label} {isTaken ? '(Obsazeno)' : isAvailable ? `(${availableSpots}/${maxCapacity} míst)` : ''}
                      </option>
                    );
                  })}
                </select>
                {errors2.time_slot && (
                  <p className="text-red-400 text-sm mt-1">{errors2.time_slot}</p>
                )}
              </div>

              <div className="mt-auto">
                <button
                  type="submit"
                  className="w-full beetlejuice-green text-black py-4 rounded-xl text-lg font-semibold beetlejuice-hover beetlejuice-border beetlejuice-glow"
                >
                  👻 Rezervovat Dům šepotů
                </button>

                <div className="text-center pt-4">
                <p className="text-gray-300 mb-3">Už máte rezervaci?</p>
                <Link
                  to="/manage"
                  className="inline-block bg-gray-800 hover:bg-gray-700 text-gray-300 px-6 py-2 rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:scale-105 border border-green-600 hover:border-green-500"
                >
                 Spravovat Existující Rezervace
                </Link>
                </div>
              </div>
            </form>
          </div>

          {/* Third Reservation Form - Prokletá komnata */}
          <div className="bg-gray-900/80 border-2 border-green-800 rounded-3xl shadow-2xl p-8 backdrop-blur-sm beetlejuice-glow flex flex-col h-full">
            <h2 className="text-2xl font-bold text-green-400 mb-6 text-center drop-shadow-lg">
              🏚️ Prokletá komnata 🏚️
            </h2>
            <p className="text-gray-300 mb-6 text-center text-sm leading-relaxed h-28 flex items-center justify-center">
              Vhodné pro všechny, jak starší, tak mladší. Délka aktivity: ~ 5 min
            </p>


            <form onSubmit={handleSubmit3} className="space-y-6 flex flex-col flex-grow">
              {/* Team Information */}
              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  🏚️ Název týmu *
                </label>
                <input
                  type="text"
                  name="team_name"
                  value={formData3.team_name}
                  onChange={handleInputChange3}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors3.team_name ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte název vašeho týmu"
                />
                {errors3.team_name && (
                  <p className="text-red-400 text-sm mt-1">{errors3.team_name}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  🔐 Heslo *
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData3.password}
                  onChange={handleInputChange3}
                  required
                  minLength="4"
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white placeholder-gray-400 ${
                    errors3.password ? 'border-red-500' : 'border-green-600'
                  }`}
                  placeholder="Zadejte heslo (min. 4 znaky)"
                />
                {errors3.password && (
                  <p className="text-red-400 text-sm mt-1">{errors3.password}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  👥 Počet účastníků *
                </label>
                <select
                  name="team_number"
                  value={formData3.team_number}
                  onChange={handleInputChange3}
                  required
                  className="w-full px-4 py-3 border border-green-600 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white"
                >
                  {[1, 2].map((num) => (
                    <option key={num} value={num}>
                      {num} {num === 1 ? "Účastník" : "Účastníků"}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-green-300 mb-2">
                  ⏰ Časový slot *
                </label>
                <select
                  name="time_slot"
                  value={formData3.time_slot}
                  onChange={handleInputChange3}
                  onClick={fetchTimeAvailability3}
                  required
                  className={`w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-200 bg-gray-800 text-white ${
                    errors3.time_slot ? 'border-red-500' : 'border-green-600'
                  }`}
                >
                  <option value="">Vyberte čas</option>
                  {[
                    { value: "15:00", label: "15:00" },
                    { value: "15:10", label: "15:10" },
                    { value: "15:20", label: "15:20" },
                    { value: "15:30", label: "15:30" },
                    { value: "15:40", label: "15:40" },
                    { value: "16:00", label: "16:00" },
                    { value: "16:10", label: "16:10" },
                    { value: "16:20", label: "16:20" },
                    { value: "16:30", label: "16:30" },
                    { value: "16:40", label: "16:40" },
                    { value: "17:00", label: "17:00" },
                    { value: "17:10", label: "17:10" },
                    { value: "17:20", label: "17:20" },
                    { value: "17:30", label: "17:30" },
                    { value: "17:40", label: "17:40" },
                    { value: "18:00", label: "18:00" },
                    { value: "18:10", label: "18:10" },
                    { value: "18:20", label: "18:20" },
                    { value: "18:30", label: "18:30" },
                    { value: "18:40", label: "18:40" },
                    { value: "19:00", label: "19:00" },
                    { value: "19:10", label: "19:10" },
                    { value: "19:20", label: "19:20" },
                    { value: "19:30", label: "19:30" },
                    { value: "19:40", label: "19:40" }
                  ].map((slot) => {
                    const isAvailable = timeAvailability3[slot.value] !== false;
                    const isTaken = timeAvailability3[slot.value] === false;
                    const capacity = capacityInfo3[slot.value];
                    const availableSpots = capacity?.available_spots || 0;
                    const maxCapacity = capacity?.max_capacity || 2;
                    
                    return (
                      <option 
                        key={slot.value} 
                        value={slot.value}
                        style={{
                          backgroundColor: isTaken ? '#fee2e2' : isAvailable ? '#dcfce7' : 'white',
                          color: isTaken ? '#dc2626' : isAvailable ? '#16a34a' : 'black'
                        }}
                        disabled={isTaken}
                      >
                        {slot.label} {isTaken ? '(Obsazeno)' : isAvailable ? `(${availableSpots}/${maxCapacity} míst)` : ''}
                      </option>
                    );
                  })}
                </select>
                {errors3.time_slot && (
                  <p className="text-red-400 text-sm mt-1">{errors3.time_slot}</p>
                )}
              </div>

              <div className="mt-auto">
                <button
                  type="submit"
                  className="w-full beetlejuice-green text-black py-4 rounded-xl text-lg font-semibold beetlejuice-hover beetlejuice-border beetlejuice-glow"
                >
                  🏚️ Rezervovat Prokletou komnatu
                </button>

                <div className="text-center pt-4">
                <p className="text-gray-300 mb-3">Už máte rezervaci?</p>
                <Link
                  to="/manage"
                  className="inline-block bg-gray-800 hover:bg-gray-700 text-gray-300 px-6 py-2 rounded-xl font-semibold transition-all duration-200 hover:shadow-lg transform hover:scale-105 border border-green-600 hover:border-green-500"
                >
                  Spravovat Existující Rezervace
                </Link>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* Contact Info at the end */}
        <div className="mt-12 text-center">
          <div className="bg-gray-900/80 border-2 border-green-800 rounded-3xl shadow-2xl p-6 backdrop-blur-sm beetlejuice-glow max-w-2xl mx-auto">
            <h3 className="text-xl font-bold text-green-400 mb-4 drop-shadow-lg">
              👻 Kontaktní informace z říše mrtvých
            </h3>
            <p className="text-gray-300">
              V případě problémů s rezervací kontaktujte záhrobí: 
              <span className="text-green-400 font-semibold"> +420 739 271 855</span>
            </p>
          </div>
        </div>
      </div>

      <Footer />

      {/* QR Code Popup */}
      <div style={{ position: 'relative', zIndex: 20 }}>
        <QRCodePopup 
          isOpen={qrPopupOpen}
          onClose={() => setQrPopupOpen(false)}
          reservationData={qrReservationData}
        />
      </div>
    </div>
  );
};

export default ReservationPage;
